import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { FormControl as FormControl$1, formLabelClasses, inputBaseClasses, buttonBaseClasses, menuItemClasses, outlinedInputClasses, InputLabel, Select } from '@mui/material';
import { styled, css } from '@mui/system';
import { isEmpty } from 'lodash';
import { switchProp } from 'styled-tools';
import { shouldNotForwardProps, withUtility, palette, shape, spacing } from '../../foundation/utils.js';

let _ = t => t,
  _t,
  _t2,
  _t3;
const FormControl = styled(FormControl$1, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _`
  ${0}

  .filter-chip-select.${0} {
    transform: none;
    left: 12px;
    color: ${0};
    font-size: 14px;
    top: ${0};
  }

  .filter-chip-select.${0} {
    font-size: ${0};
  }

  .filter-chip-select.${0} {
    height: ${0};

    border-radius: ${0};
  }

  .filter-chip-select .${0}.${0} {
    padding-top: ${0};
    padding-bottom: ${0};
    padding-left: ${0};
    padding-right: ${0};
  }

  ${0}
`), withUtility(({}, {
  fullWidth
}) => {
  if (!fullWidth) {
    return;
  }
  return css(_t2 || (_t2 = _`
      width: 100%;
    `));
}), formLabelClasses.root, palette('onSurface'), switchProp('size', {
  small: '3px',
  normal: '8px'
}), inputBaseClasses.input, switchProp('size', {
  small: '12px',
  normal: '14px'
}), inputBaseClasses.root, switchProp('size', {
  small: '36px',
  normal: '40px'
}), shape('small'), buttonBaseClasses.root, menuItemClasses.root, spacing(3), spacing(3), spacing(4), spacing(4), withUtility(({
  palette
}, {
  internalVariant
}) => {
  const selected = internalVariant === 'selected';
  return css(_t3 || (_t3 = _`
      .filter-chip-select
        .${0},
        .${0}:hover
        .${0} {
        border-color: ${0};
      }

      .filter-chip-select.${0}.${0} fieldset {
        border-color: ${0};
        border-width: 1px;
      }

      .filter-chip-select.${0} {
        background: ${0};
      }
    `), outlinedInputClasses.notchedOutline, inputBaseClasses.root, outlinedInputClasses.notchedOutline, palette(selected ? 'surfaceVariant' : 'outline'), inputBaseClasses.root, inputBaseClasses.focused, palette('outline'), inputBaseClasses.root, selected ? palette('surfaceVariant') : 'transparent');
}));
const FilterChipSelect = _a => {
  var {
      children,
      size = 'normal',
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      maxWidth,
      marginY,
      placeholder,
      fullWidth,
      mb,
      ml,
      mr,
      mt,
      disablePortal = false,
      mx,
      my,
      variant = 'unselected'
    } = _a,
    props = __rest(_a, ["children", "size", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight", "m", "marginX", "maxWidth", "marginY", "placeholder", "fullWidth", "mb", "ml", "mr", "mt", "disablePortal", "mx", "my", "variant"]);
  const canRenderPlaceholder = placeholder && (props.value === '' || isEmpty(props.value));
  return jsxs(FormControl, Object.assign({
    internalVariant: variant,
    size: size,
    error: props.error,
    fullWidth: fullWidth,
    disabled: props.disabled,
    sx: {
      maxWidth,
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      marginY,
      mb,
      ml,
      mt,
      mr,
      mx,
      my
    },
    className: "filter-chip-select"
  }, {
    children: [canRenderPlaceholder && jsx(InputLabel, Object.assign({
      className: "filter-chip-select",
      shrink: false
    }, {
      children: placeholder
    })), jsx(Select, Object.assign({
      size: size
    }, props, {
      notched: false,
      MenuProps: {
        disablePortal,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        PaperProps: {
          sx: {
            transform: 'translateX(7px) !important;'
          }
        }
      },
      sx: {
        height: 300
      },
      className: "filter-chip-select"
    }, {
      children: children
    }))]
  }));
};

export { FilterChipSelect };
